const LEVEL_THRESHOLDS = [
  0, 250, 500, 1000, 1500, 2000, 3000, 4000, 5500, 7500, 10000,
] as const;
const LEVEL_COLORS = [
  0x00bb66, 0xcc0033, 0x0066ff, 0x993300, 0xcccccc, 0xffbb22, 0x552266,
] as const;

export enum BadgeType {
  Player = 1,
  Team = 2,
  School = 3,
}

export function getSkillLevel(stickers: number) {
  let level = 1;

  for (
    ;
    LEVEL_THRESHOLDS[level] !== undefined &&
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    stickers >= LEVEL_THRESHOLDS[level]!;
    level++ // eslint-disable-next-line no-empty
  ) {}
  const MAX_LEVEL = 10;
  const STICKERS_PER_LEVEL = 1000;
  if (level > MAX_LEVEL) level = 1 + Math.floor(stickers / STICKERS_PER_LEVEL);
  return level;
}

export function getSkillBadgeProperties(stickers: number) {
  const level = getSkillLevel(stickers);
  let shapeFrame: number;
  let shapePercent: number;
  let colorIndex: number;
  let colorPercent: number;

  if (level > 10) {
    shapeFrame = 7;
    shapePercent = 100;
    colorIndex = 6;
    colorPercent = 100;
  } else {
    const previousLevelThreshold = LEVEL_THRESHOLDS[level - 1]!;
    const nextLevelThreshold = LEVEL_THRESHOLDS[level]!;

    shapePercent =
      (stickers - previousLevelThreshold) /
      (nextLevelThreshold - previousLevelThreshold);
    if (stickers == 0) shapePercent = 0;
    shapeFrame = Math.ceil(shapePercent * 6);
    if (shapeFrame == 0) shapeFrame = 1;

    colorPercent = shapePercent * 6 - shapeFrame + 1;
    if (colorPercent >= 1) colorPercent = 0;
    colorIndex = Math.floor(colorPercent * 6);
    if (colorIndex == 6) colorIndex = 5;
  }

  return {
    level,
    shapeFrame,
    shapePercent,
    color: LEVEL_COLORS[colorIndex] ?? LEVEL_COLORS[LEVEL_COLORS.length - 1]!,
    colorPercent,
  };
}
